import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import "../../style.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Techstack from "./Techstack";
import Aboutcard from "./AboutCard";

function About() {
    return (
        <Container fluid className="about-section">
            <Particle />
            <Container>
                <Row style={{ justifyContent: "center", padding: "10px" }}>
                    <Col
                        md={7}
                        sm={12}
                        style={{
                            justifyContent: "center",
                            paddingTop: "30px",
                            paddingBottom: "50px",
                            paddingRight: "50px",
                            textAlign: "center",
                        }}
                    >
                        <h1 style={{ fontSize: "2.1em", paddingBottom: "20px" }}>
                            My<strong className="purple"> professional experiences</strong>
                        </h1>
                        <Aboutcard />
                    </Col>
                    <Col
                        md={5}
                        sm={12}
                        style={{
                            paddingTop: "30px",
                            paddingBottom: "50px",
                            textAlign: "center",  // Center the text within the column
                        }}
                        className="about-img"
                    >
                        <h1 className="project-heading" style={{ fontSize: "2em" }}>
                            <strong className="purple">Tools</strong> I use
                        </h1>
                        <Row
                            style={{
                                display: "flex",
                                justifyContent: "space-evenly",
                                flexWrap: "wrap", // Allows the icons to wrap if needed
                                paddingBottom: "50px",
                            }}
                        >
                            <Col xs={6} sm={4} md={3} style={{ display: "flex", justifyContent: "center", padding: "10px" }}>
                                <Techstack iconName="devicon-java-plain-wordmark" />
                            </Col>
                            <Col xs={6} sm={4} md={3} style={{ display: "flex", justifyContent: "center", padding: "10px" }}>
                                <Techstack iconName="devicon-maven-plain-wordmark" />
                            </Col>
                            <Col xs={6} sm={4} md={3} style={{ display: "flex", justifyContent: "center", padding: "10px" }}>
                                <Techstack iconName="devicon-python-plain-wordmark" />
                            </Col>
                            <Col xs={6} sm={4} md={3} style={{ display: "flex", justifyContent: "center", padding: "10px" }}>
                                <Techstack iconName="devicon-angular-plain-wordmark" />
                            </Col>
                            <Col xs={6} sm={4} md={3} style={{ display: "flex", justifyContent: "center", padding: "10px" }}>
                                <Techstack iconName="devicon-react-plain-wordmark" />
                            </Col>
                            <Col xs={6} sm={4} md={3} style={{ display: "flex", justifyContent: "center", padding: "10px" }}>
                                <Techstack iconName="devicon-javascript-plain" />
                            </Col>
                            <Col xs={6} sm={4} md={3} style={{ display: "flex", justifyContent: "center", padding: "10px" }}>
                                <Techstack iconName="devicon-typescript-plain" />
                            </Col>
                            <Col xs={6} sm={4} md={3} style={{ display: "flex", justifyContent: "center", padding: "10px" }}>
                                <Techstack iconName="devicon-nodejs-plain-wordmark" />
                            </Col>
                            <Col xs={6} sm={4} md={3} style={{ display: "flex", justifyContent: "center", padding: "10px" }}>
                                <Techstack iconName="devicon-express-original-wordmark" />
                            </Col>
                            <Col xs={6} sm={4} md={3} style={{ display: "flex", justifyContent: "center", padding: "10px" }}>
                                <Techstack iconName="devicon-postgresql-plain-wordmark" />
                            </Col>
                            <Col xs={6} sm={4} md={3} style={{ display: "flex", justifyContent: "center", padding: "10px" }}>
                                <Techstack iconName="devicon-php-plain" />
                            </Col>
                            <Col xs={6} sm={4} md={3} style={{ display: "flex", justifyContent: "center", padding: "10px" }}>
                                <Techstack iconName="devicon-git-plain-wordmark" />
                            </Col>
                            <Col xs={6} sm={4} md={3} style={{ display: "flex", justifyContent: "center", padding: "10px" }}>
                                <Techstack iconName="devicon-cplusplus-line" />
                            </Col>
                            <Col xs={6} sm={4} md={3} style={{ display: "flex", justifyContent: "center", padding: "10px" }}>
                                <Techstack iconName="devicon-c-line" />
                            </Col>
                        </Row>
                        <Row
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                paddingBottom: "50px",
                            }}
                        >
                            <Col xs={6} sm={4} md={3} style={{ display: "flex", justifyContent: "center", padding: "10px" }}>
                                <Techstack iconName="devicon-linux-plain" />
                            </Col>
                            <Col xs={6} sm={4} md={3} style={{ display: "flex", justifyContent: "center", padding: "10px" }}>
                                <Techstack iconName="cib-visual-studio-code" />
                            </Col>
                            <Col xs={6} sm={4} md={3} style={{ display: "flex", justifyContent: "center", padding: "10px" }}>
                                <Techstack iconName="cib-postman" />
                            </Col>
                        </Row>
                        <Particle />
                    </Col>
                </Row>
            </Container>
        </Container>
    );
}

export default About;
